export default {
    "entry": {
        "mainOrderAndInfo": "Import Shipping Order",
        "downloadMainOrderAndInfo": "download the import shipping order template",
        "mainOrderNoInfo": "Import Direct Schedule",
        "downloadMainOrderNoInfo": "download the import direct schedule template",
        "orderImportSuccess": "the transport order is successfully imported",
        "void": "delete",
        "inputOrderTips": "please enter the transport order \\ outer order",
        "orderStatus": "Status",
        "element": "yuan",
        "confirmOperationErrorPrompt": "confirm the operation error prompt",
        "batchModifiy": "batch edit",
        "modifiyTips": "filled in the fields that need to be modified together, other fields keep empty",
        "dispatchErrorTips": "error message for direct scheduling operation",
        "dispatchSuccessTips": "successful dispatch",
        "currentDataNotUse": "the current data status is not operable",
        "reviewed": "confirmed",
        "checkDataTips": "please check the data with [order_confirmed] status!",
        "voidTips": "do you want to delete the selected shipping order.",
        "importOrder": "import shipping order",
        "otherInfo": "Other Information",
        "custom": "customize",
        "editingPageTips": "transport order details editing page",
        "orderDetaile": "detailed goods quantity of the order",
        "attachmentTips": "attachment on the order"
    },
    "entryCreate": {
        "origin": "Origin",
        "destination": "Destination",
        "againOrder": "copy a new order",
        "directDispatch": "Direct Schedule",
        "receiptQtyTips": "Please enter number of receipts",
        "originNoTips": "Please enter upstream tracking number",
        "transferNoTips": "Please enter external tracking number",
        "customerSAPCodeTips": "Please enter customer SAP code",
        "remarkTips": "Remark (maximum 250 characters)",
        "bizTypeTips": "Please enter business type",
        "noteTips": "Note",
        "receiptTypeTips": "Please select receipt type",
        "transferNoTips": "Please enter external tracking number",
        "shipperTips": "Please select the customer name",
        "partnerNameTips": "Please select Surcharge/Discount Group",
        "orderQuantity": "order quantity",
        "doubleClickRestore": "double click to restore the order value",
        "temperatureControlNameTips": "Please select the temperature type",
        "volumeTips": "Please enter the volume (cubic meter)",
        "packingQtyTips": "Please enter total number of package",
        "weightTips": "Please enter weight (kg)",
        "goodsQtyTips": "Please enter total number of item per packages",
        "receivedPackingQtyTips": "Enter Actual Total Number of Packages Received",
        "paidPackingQtyTips": "Enter Actual Total Number of Packages Paid",
        "goodsValueTips": "Please enter declare value",
        "goodsTypeTips": "Please select item type",
        "requirement": "require",
        "deliverGoods": "ship",
        "pleaseEnter": "Please enter ",
        "pleaseSelect": "Please select ",
        "receivingGoods": "receive goods",
        "pleaseSelectDate": "Please select the time",
        "pleaseSelectProvinceAndCityAndDistrict": "Please enter province, city, district",
        "pleaseEnterProvinceDistrictSub_district":"Please enter Province, District, Sub-district",
        "addressTips": "Please select Address",
        "pickupCommentsTips": "Please enter product description",
        "carrierProductNotEmpty": "Surcharge/Discount Group cannot be empty!",
        "latestReceivedDtTips": "the latest shipping time cannot be later than the latest receving time!",
        "latestDeliveryDtTips": "the latest receving time cannot be earlier than the latest shipping time!",
        "cloneOrderTips": "for successful cloned transportation order data, please adjust the transport order parameters according to the specific situation.",
        "isInsuranceTips": "when the insured is checked, the statement must be greater than 0",
        "dispatchFailedTips": "direct schedule failed",
        "vehicleTypeTips": "please select a Vehicle Type"
    }
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/order/order.js